// import extractSizesAssociatedToColor from '../../components/add-to-cart-alt/extractSizesAssociatedToColor';
import { filtered_products, filtered_products_search } from './filtering';
import { getSizedImageURL } from '../../core/images';

const getProductJson = (tile) => {
  const is_search = document.querySelector('body').classList.contains('has-overlay-search');
  let product_json = null;

  if (is_search) {
    product_json = window.theme.search.products;
  } else if (document.querySelector('body').classList.contains('template-collection')) {
    // Use _.filter because we can have multiple same product id on sliced products
    // See /collections/the-lace-midi-dress or /collections/the-gaia-midi-dress
    product_json = is_search ? _.filter(filtered_products_search, { product_id
      : String(tile.dataset.productId) }) : _.filter(filtered_products, { product_id
        : String(tile.dataset.productId) });
  } else if (document.querySelector('body').getAttribute('class').includes('lookbook')) {
    product_json = _.find(window.theme.lookbook_products, { handle: tile.dataset.productHandle });
  } else {
    const product_list = _.find(window.theme.collections.data, { handle: 'product-list' });
    if (typeof product_list !== 'undefined') {
      product_json = _.filter(product_list.products, { id: Number(tile.dataset.productId) });
    }
  }

  return product_json;
};

// Update the flag if there's a variant metafield flag is available, else we restore the default flag
// Priority: Best Seller app flag > Trending app flag > Style metafield flag > Tag-based flag
const updateTileFlag = (product_json, swatch) => {
  const tile = swatch.closest('.product-tile');

  if (!tile.querySelector('.product-tile__flags')) {
    return;
  }

  const color_value = swatch.dataset.colorValue;
  // const p_json = (Array.isArray(product_json)) ? _.find(product_json, { skus: [{ color_value }] }) : product_json;
  const p_json = (Array.isArray(product_json)) ? product_json.flatMap(product => product.skus.filter(sku => sku.custom_fields?.Color === color_value)) : product_json;

  if (typeof p_json === 'undefined' || p_json === null) {
    return;
  }

  const is_plus = color_value.includes('Plus Size -');

  // We don't have the value on a single size anymore
  // Find the 1st value of the metafield tag if any
  const flag_standard_size_value = p_json.find(sku =>  sku.custom_fields?.['astr-style_flag'])?.custom_fields?.['astr-style_flag'] ?? '';
  const flag_plus_size_value = p_json.find(sku =>  sku.custom_fields?.['astr-style_flag_plus_sizes'])?.custom_fields?.['astr-style_flag_plus_sizes'] ?? '';
  const flag_custom_value = (flag_standard_size_value === '' && flag_plus_size_value === '') ? '' : (is_plus) ? flag_plus_size_value : flag_standard_size_value;

  const tag_flag = tile.querySelector('.product-tile__flag--tag');
  const app_flag = tile.querySelector('.product-tile__flag--app');
  const custom_flag = tile.querySelector('.product-tile__flag--custom');

  // Can be different by style - will need to be re-created
  if (custom_flag) { custom_flag.remove(); }

  if (flag_custom_value === '') {
    // Show the default flag
    if (tag_flag) { tag_flag.classList.remove('visually-hidden'); }
    if (app_flag) { app_flag.classList.remove('visually-hidden'); }
  } else {
    // Create and show the custom tag if no app flag / Hide the tag-based flag
    if (tag_flag) { tag_flag.classList.add('visually-hidden'); }
    if (app_flag) { app_flag.classList.add('visually-hidden'); }

    const custom_flag_element = document.createElement('div');
    custom_flag_element.classList.add('product-tile__flag');
    custom_flag_element.classList.add('product-tile__flag--custom');
    custom_flag_element.innerHTML = flag_custom_value;
    tile.querySelector('.product-tile__flags').appendChild(custom_flag_element);
  }
};

export default () => {
  // Can be initialized from sevaral parts (PLP, search overlay, recommendation lists...)
  if (window.select_new_color_init === true) {
    return;
  }

  window.select_new_color_init = true;

  $(document).on('click touchend', '[data-product-tile] [data-color-swatch]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    const item = e.currentTarget;

    if (item.classList.contains('active')) {
      return;
    }

    const tile = item.closest('.product-tile');
    const tile_image = tile.querySelector('[data-product-tile-image]');
    const selected_first_variant_id = parseInt(item.dataset.variantId, 10);
    const is_search = document.querySelector('body').classList.contains('has-overlay-search');

    Array.from(tile.querySelectorAll('[data-color-swatch]')).forEach((element) => {
      element.classList.remove('active');
    });
    item.classList.add('active');

    let image_class = '';
    let image_wrapper = '';
    if (tile_image.querySelector('.responsive-image__wrapper') !== null) {
      image_class = 'responsive-image__image';
      image_wrapper = ' .responsive-image__wrapper';
    }

    // const placeholder = 'https://cdn.shopify.com/s/files/1/2483/6632/files/product-tile-bkg.gif?v=1611803919';
    const placeholder = window.theme.collections.placeholder;

    // Load the new images (sizes are defined in collection-grid-swatch.liquid)
    if (typeof item.dataset.front !== 'undefined' && item.dataset.front !== '' && !item.dataset.front.includes('<svg')) {
      // $tile_image.find(`[data-product-main-image]${image_wrapper}`).addClass('hidden-when-not-loaded').html(`<img src="${$item.data('front').replace('300x460', '1x460')}" data-src="${$item.data('front')}" alt="${$tile.find('[data-product-tile-title] a').text()} - ${$item.data('color-value')} - Front" class="lazyload blur-up ${image_class}" />`);

      let front_img_src = (item.dataset.front.includes('crop=center')) ? item.dataset.front : getSizedImageURL(item.dataset.front, '600x920_crop_center');
      // let front_img_src = $item.data('front');

      // const front_img_placeholder_src = getSizedImageURL($item.data('front'), '1x_crop_center');
      // const front_img_placeholder_src = 'https://cdn.shopify.com/s/files/1/2483/6632/files/pixel-grey.png?v=1687192560';
      // front_img_src = progressiveJpg($item.data('front'));
      // https://cdn.shopify.com/s/files/1/2483/6632/products/ADR101502_SILVERFLORAL_1_300x460_crop_center@2x.jpg?v=1678350907
      let img_dimensions = `width="300" height="460"`;
      if (window.theme.breakpoints.current === 'mobile') {
        front_img_src = front_img_src.replace('300x460', '150x230');
        img_dimensions = `width="150" height="230"`;
      }

      tile_image.querySelector(`[data-product-main-image]${image_wrapper}`).innerHTML = `<img loading="lazy" src="${front_img_src}" alt="${item.dataset.frontAlt}" class="${image_class}" ${img_dimensions} onError="this.src = '${placeholder}';" />`;

      // $tile_image.find(`[data-product-main-image]${image_wrapper}`).css({'background-image': `url(${$item.data('front').replace('300x460', '1x1')})`, 'background-size': '100%'});
      // $tile_image.find(`[data-product-main-image]${image_wrapper}`).css({'background-image': `url(${placeholder})`, 'background-size': '100%'});
    }

    if (typeof item.dataset.back !== 'undefined' && item.dataset.back !== '' && tile_image.querySelector('[data-product-alt-image]') !== null) {
      // const back_size_desktop = '300x460_crop_center@2x.progressive';
      let back_img_src = (item.dataset.back.includes('crop=center')) ? item.dataset.back : getSizedImageURL(item.dataset.back, '600x920_crop_center');
      // let back_img_src = $item.data('back');

      // const back_img_placeholder_src = getSizedImageURL($item.data('back'), '20x_crop_center@2x.progressive');
      // const back_img_placeholder_src = 'https://cdn.shopify.com/s/files/1/2483/6632/files/pixel-grey.png?v=1687192560';
      let back_img_dimensions = `width="300" height="460"`;
      // const back_img_src = progressiveJpg($item.data('back'));
      if (window.theme.breakpoints.current === 'mobile') {
        back_img_src = back_img_src.replace('300x460', '150x230');
        back_img_dimensions = `width="150" height="230"`;
      }

      tile_image.querySelector(`[data-product-alt-image]${image_wrapper}`).innerHTML = `<img src="${back_img_src}" alt="${item.dataset.backAlt}" class="${image_class}" ${back_img_dimensions} onError="this.src = '${placeholder}';" />`;
    }

    // Change the product url
    const original_url = tile.dataset.productUrl;
    let new_url = original_url;
    new_url += new_url.includes('?') ? '&' : '?';
    new_url += `color=${item.dataset.colorValue}`;
    tile.querySelector('[data-product-tile-image]').setAttribute('href', new_url);
    tile.querySelector('[data-product-tile-title] a').setAttribute('href', new_url);

    /** Add to cart alt - START **/
    // Lookbook pages, reinit add to cart button
    // if ($tile.parent().hasClass('gallery-products-carousel__products')) {
    // $tile.find('[data-add-to-cart-alt-button]').html(`<span>${window.theme.strings.addToCart}</span>`);

    const product_json = getProductJson(tile);

    // Don't forget to update the code for the desktop version in components/add-to-catr-alt/index.js
    if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
      // Preselect the 1st size available
      window.setTimeout(() => {
        const available_sizes = tile.querySelectorAll('[data-size-button].available');
        if (available_sizes.length > 0) {
          const first_available_size = available_sizes[0];
          // $first_available_size.addClass('active'); // not sure why this doesn't work
          tile.querySelector('[data-add-to-cart-alt-button]').dataset.selectedVariantId = first_available_size.dataset.variantId;
        }
      }, 1);
    }
    // }

    /** Add to cart alt - END **/

    // Update the wishlist button
    const wishlist_event = new CustomEvent('tile-variant:change', { bubbles: true });
    wishlist_event.data = { detail: { variantId: selected_first_variant_id, tile: $(tile) } };
    document.dispatchEvent(wishlist_event);

    updateTileFlag(product_json, item);
  });
};
